<template>
  <div>  
         
    <v-container grid-list-xl> 
        <v-layout align-center="" justify-center="">
            <v-col sm="12" cols="12">
                <v-card > 
                    <not-cpanel-tab 
                        :not_show="true"
                        :not="not" />
                    <v-card-title class="primary white--text" >
                        <div class="not-f7 font-italic ">
                            You have {{messagesSize}} received Messages
                        </div>
                    </v-card-title> 
                    <v-layout v-if="!page_show">
                        <not-page-spinner :not_show="true" /> 
                    </v-layout>   
                    <div v-else>
                        <v-card-text class="primary lighten-5 pa-5" v-if="messages">
                            <v-row>
                                <v-col sm="6" v-for="(sms, index) in p_messages.list" :key="index"> 
                                    <v-card height="100%">
                                        <v-card-actions>
                                            <v-list-item>
                                                <v-list-item-avatar color="primary" dark>
                                                    <v-icon dark>person</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{sms.first_name}} {{sms.last_name}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{sms.phoneNumber}}</v-list-item-subtitle>
                                                    <v-list-item-subtitle>{{sms.email}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-btn @click="deleteMessage(sms.key)"  icon=""><v-icon>delete</v-icon></v-btn>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-card-actions>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            <div class="font-weight-bolds font-italic">{{not.convertDate(sms.date)}}</div>
                                            <div class="font-weight-bold not-f5 pb-2">{{sms.subject}}</div>
                                            <!-- <div>{{sms.message}}</div> -->
                                            <div v-for="(line, index) in sms.message.split('\n')" :key="index">{{line}} <br> </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <br>
                            <v-divider></v-divider>
                            <div class="px-5">
                                <v-pagination
                                    v-model="page_current"
                                    class="mt-4"
                                    :length="p_messages?p_messages.pages:0"/> 
                            </div>
                        </v-card-text> 
                    </div>
                </v-card>
            </v-col>  
        </v-layout>
    </v-container> 
    <br>
  </div> 
</template>

<script>
let pageName = "Messages"
    export default {
        name:pageName,
        props:["not"],
        data() {
            return {
                page_current:1,
                page_size:10,
                page_show:false,
                dialogMessage: false,
                load:false,
                input_name:'',
                input_email:'',
                input_phoneNumber:'',
                input_address:'',
                input_message:'',
                tab: null,
                items: [
                    'Login', 'Register', ,
                ], 
                images:[
                    {src:require(`@/assets/awrim/group/g4.jpeg`),local:true},  
                ] 
            }
        },
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notText:false,
                notIndicators:true,
                notHeight:"250",
                notImages:this.images
            })
            this.pageLoad(1000)
        },
        computed: {
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            messages(){
                return this.$store.getters.getMessages
            },
            messagesSize(){
                return this.messages?this.messages.length:0
            },
            p_messages(){
                if (!this.messages) {
                    return null
                }
                let list = [...this.messages]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            }
        },
        methods: {
            notYesDialog(action){
                if (action.code) {
                    if (action.code==="1") {
                        this.$store.dispatch("fi_delete",{
                            action:"Message",
                            path:"TERESIAN/MESSAGES/"+action.key
                        }) 
                    }
                }
                 
            },  
            deleteMessage(key){
                this.not.notDialog(true,true,"DELETE","Are you sure you want to delete this message","Cancel","Delete",{
                    code:"1",
                    key:key
                }) 
            },

            //LOAD
            show(){
                if (!this.us) {
                    this.not.go("/")
                }
            },
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false  

                    if (ps) {
                        let getting = ps.find(process=>{
                            return process.name == 'getting/Messages'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'deleting/Message'
                        })
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/Message'
                        })

                        if (getting) {
                            this.page_show =false  
                        }else{
                            this.page_show =true 
                        } 
                        if (deleting) {
                            this.not.notDialogP(true,true,'Deleting...') 
                        }else{  
                        } 

                    }else{
                       this.page_show =true  
                       
                    }

                    //check response
                    if (res.res==='deleting/Message/successful') { 
                        this.not.notDialog(true,true,'Successful','Message, successfully deleted.','','OK','') 
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='deleting/Message/error'){
                        this.formRes() 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting message.','','OK','') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            }
        },
        watch: {
            us(v){
                this.show()
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
  }
</script>
 
